import { render, staticRenderFns } from "./Addjob.vue?vue&type=template&id=258a1e8f"
import script from "./Addjob.vue?vue&type=script&lang=js"
export * from "./Addjob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports